import { render, staticRenderFns } from "./list-formation-model.vue?vue&type=template&id=2569c41c&"
import script from "./list-formation-model.vue?vue&type=script&lang=js&"
export * from "./list-formation-model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports